import { resolve } from 'acast-www-utils';
import Descriptor, { setDescriptor } from './property-descriptor';
import { getState } from './state';

const Identity = new Descriptor();

export default function createProperty(options) {
  const d = Identity.merge(options);

  return function property(inst, name, value) {
    let descriptor = d;

    if ('initializer' in value && typeof value.initializer === 'function') {
      descriptor = d.merge(value.initializer());
    }

    if (descriptor.path === null) {
      descriptor = descriptor.merge({ path: name });
    }

    if (typeof descriptor.validate === 'function') {
      const defaultValue =
        typeof descriptor.default === 'function' ? descriptor.default() : descriptor.default;

      if (defaultValue != null && !descriptor.validate(defaultValue)) {
        // eslint-disable-next-line max-len
        throw new Error(
          `${inst.constructor.name}[${name}]: Default value is not undefined, null, or does not pass type validation.`,
          defaultValue
        );
      }
    }

    setDescriptor(inst.constructor, name, descriptor);

    Object.defineProperty(inst, name, {
      get() {
        const state = getState(this);
        let defaultValue = descriptor.default != null ? descriptor.default : undefined;
        if (typeof defaultValue === 'function') {
          defaultValue = defaultValue();
        }
        if (typeof descriptor.resolve === 'function') {
          return descriptor.resolve(state, descriptor.path, defaultValue);
        }
        return resolve(state, descriptor.path, defaultValue);
      },
    });

    return inst;
  };
}
